module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"btn-go-home-text":"Home","btn-go-back-text":"Zurück"},"fr":{"btn-go-back-text":"Retour","btn-go-home-text":"Accueil"},"it":{"btn-go-back-text":"Indietro","btn-go-home-text":"Home"}}')
  delete Component.options._Ctor
}
